import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "./PlannerSuccessModal.scss";

interface PlannerSuccessModalProps {
  open: boolean;
  onClose: () => void;
  /** Main modal title (e.g. "Successful Message") */
  title?: string;
  /** Subheading text (e.g. "Thank you") */
  subtitle?: string;
  /** Business name to be displayed in bold */
  businessName: string;
  /** Informational text shown below the main message */
  infoText?: string;
  /** Max width of the modal */
  /** Toggle close icon visibility */
  showCloseIcon?: boolean;
  isConsultant?: boolean;
}

const PlannerSuccessModal: React.FC<PlannerSuccessModalProps> = ({
  open,
  onClose,
  title = "Successful Message",
  subtitle = "Thank you",
  businessName,
  infoText = "",
  showCloseIcon = true,
  isConsultant,
}) => {
  return (
    <Dialog open={open} onClose={onClose} className="success-modal" fullWidth>
      {/* Header */}
      <DialogTitle className="success-modal__header">
        <Box className="success-modal__header-content">
          <Typography className="success-modal__title">{title}</Typography>
          {showCloseIcon && (
            <IconButton
              className="success-modal__close-btn"
              onClick={onClose}
              size="small"
            >
              <CloseIcon fontSize="large" />
            </IconButton>
          )}
        </Box>
      </DialogTitle>

      {/* Body */}
      <DialogContent className="success-modal__content">
        {subtitle && (
          <Typography className="success-modal__thank-text">
            {subtitle}
          </Typography>
        )}

        {isConsultant ? (
          <Typography className="success-modal__main-text">
            Your request for a <strong>{businessName}</strong> has been booked
            successfully.
          </Typography>
        ) : businessName ? (
          <Typography className="success-modal__main-text">
            Your request for a <strong>{businessName}</strong> quote has been
            submitted successfully.
          </Typography>
        ) : null}

        {infoText && (
          <Typography className="success-modal__info-text">
            {infoText}
          </Typography>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default PlannerSuccessModal;
